import { Component, Input } from '@angular/core';

/**
 * Page header pattern from the mockup: small label-caps eyebrow + large headline + supporting paragraph + actions slot.
 * Used at the top of every workspace section (real or stub) for consistent rhythm.
 */
@Component({
    standalone: false,
    selector: 'mkt-ws-page-head',
    template: `
<div class="ph">
    <div class="ph__left">
        <div class="ph__eyebrow" *ngIf="eyebrow">{{ eyebrow }}</div>
        <h1 class="ph__title">{{ title }}</h1>
        <p class="ph__sub" *ngIf="sub">{{ sub }}</p>
    </div>
    <div class="ph__actions" *ngIf="hasActions">
        <ng-content select="[actions]"></ng-content>
    </div>
</div>
    `,
    styles: [`
        :host { display: block; }
        .ph { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 24px; gap: 24px; }
        .ph__left { flex: 1; min-width: 0; }
        .ph__eyebrow { font-size: 10.5px; letter-spacing: 0.11em; text-transform: uppercase; font-weight: 500; color: var(--mj-text-secondary, #71717a); margin-bottom: 12px; }
        .ph__title { font-size: 30px; line-height: 1.1; letter-spacing: -0.02em; font-weight: 600; margin: 0; max-width: 760px; color: var(--mj-text-primary, #1a1a1a); }
        .ph__sub { font-size: 13.5px; color: var(--mj-text-secondary, #71717a); margin: 10px 0 0; max-width: 640px; line-height: 1.55; }
        .ph__actions { display: flex; align-items: center; gap: 8px; padding-top: 12px; flex-shrink: 0; }
        @media (max-width: 1024px) { .ph__title { font-size: 24px; } }
    `]
})
export class PageHeadComponent {
    @Input() eyebrow = '';
    @Input() title = '';
    @Input() sub = '';
    @Input() hasActions = false;
}
